import { TWithoutTypename } from './interfaces/graphql.interface';

export function removeTypename<T>(obj: T): TWithoutTypename<T> {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename) as TWithoutTypename<T>;
  } else if (obj && typeof obj === 'object') {
    const result = {} as Record<string, unknown>;
    for (const key in obj) {
      if (key !== '__typename') {
        result[key] = removeTypename(obj[key]);
      }
    }
    return result as TWithoutTypename<T>;
  }
  return obj as TWithoutTypename<T>;
}
